import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  min-height: 692px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 0;
  overflow: hidden;
  background: linear-gradient(
    108deg,
    rgba(194, 178, 128, 1) 0%,
    rgb(220, 222, 216) 100%
  );

  @media screen and (max-width: 490px){
    position: unset;
  }
`;

export const FormWrap = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  min-width: 80%;

  @media screen and (max-width:  490px) {
    margin-top: 100px;
    height: 80%;
    margin-bottom: 40px;
  }
`;

export const Icon = styled(Link)`
  margin-left: 32px;
  margin-top: 32px;
  text-decoration: none;
  color: #fff;
  font-weight: 700;
  font-size: 32px;

  @media screen and (min-width: 490px) {
    margin-left: 16px;
    margin-top: 8px;
  }
`;

export const FormContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
 

  @media screen and (min-width:  490px) {
    padding: 10px;
  }
`;

export const Form = styled.form`
  background: #fff;
  max-width: 400px;
  height: auto;
  width: auto;
  z-index: 1;
  display: grid;
  margin: 0 auto;
  padding: 80px 32px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);
  min-width: 290px;

  @media screen and (min-width: 490px) {
    padding: 32px 32px;
  }
`;

export const FormOut = styled.form`
  background: #8095A0
  height: auto;
  width: 100%;
  z-index: 1;
  display: grid;
  margin: 0 auto;
  padding: 80px 32px;
  justify-content: center;
  align-items: center;
`;

export const FormH1 = styled.h1`
  margin-bottom: 40px;
  color: gray;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
`;

export const FormLabel = styled.label`
  margin-bottom: 8px;
  font-size: 14px;
  color: gray;
`;
export const FormInput = styled.input`
  padding: 16px 16px;
  margin-bottom: 32px;
  border-radius: 2px;
  &:focus {
    outline: none;
    border: 2px solid #c2b280
  }
`;

export const FormButton = styled.button`
  background: #c2b280;
  padding: 16px 0;
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  &:focus {
    outline: none;
    border: 2px solid #c2b280
  }
`;

export const Text = styled.span`
  text-align: center;
  margin-top: 24px;
  color: black;
  font-size: 14px;
  font-weight: bold;
  padding-bottom: 20px;
`;

export const ErrorText = styled.span`
  text-align: center;
  margin-top: 24px;
  color: Red;
  font-size: 14px;
  padding-bottom: 20px;
`;

export const NavBtnLink = styled(Link)`
  border-radius: 50px;
  background: #c2b280;
  white-space: nowrap;
  padding: 10px 22px;
  color: #fff;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #c2b280;
  }
`;

export const SignUpTermsContainer = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  padding-bottom: 20px;
`;

export const Checkbox = styled.input`
  color: #fff;
`

export const CheckboxText = styled.span`
  text-align: center;
  color: #fff;
  font-size: 14px;
`;
